import { cn } from '@/lib/utils'

interface Props {
  className?: string
  currentStep: number
  totalSteps: number
  stepLabels?: string[]
  upperStepLabels?: string[]
}

export const Stepper = ({ className, currentStep, totalSteps, stepLabels, upperStepLabels }: Props) => {
  const hasUpperStepLabels = upperStepLabels?.length
  return (
    <div className={cn('flex items-start gap-2', className)}>
      {Array.from({ length: totalSteps }, (_, index) => (
        <div key={index} className='flex min-w-0 flex-1 flex-col items-center gap-2'>
          {upperStepLabels?.[index] ? (
            <span className='text-center text-base leading-tight select-none'>{upperStepLabels[index]}</span>
          ) : hasUpperStepLabels ? (
            <span className='text-center text-base leading-tight opacity-0'>X</span>
          ) : null}
          <div
            className={cn(
              'h-1 rounded-full',
              index === currentStep ? 'bg-icon-default' : 'bg-button-secondary-border-disabled',
              stepLabels?.length ? 'w-full' : 'w-12'
            )}
          />
          {stepLabels?.[index] ? (
            <span
              className={cn(
                'text-center text-base leading-tight select-none',
                index === currentStep ? 'text-foreground font-medium' : 'text-muted-foreground'
              )}
            >
              {stepLabels[index]}
            </span>
          ) : null}
        </div>
      ))}
    </div>
  )
}
